import {UmpireMatch} from '../umpire-match';
import {UmpireArticle} from '../umpire-article';
import {UmpireRound} from '../umpire-round';
import {UmpirePublicationOptions} from '../umpire-publication-options';
import {UmpirePageType} from '../umpire-page-type';
import {UmpirePushNotificationTarget} from '../umpire-push-notification-target';

export class UmpirePushNotification implements UmpirePublicationOptions {
  id!: string;

  name!: string | null;

  resource!:
    | UmpireArticle
    | UmpireMatch
    | UmpireRound
    | UmpirePageType
    | UmpirePushNotificationTarget;

  body!: string | null;

  title!: string | null;

  publication_time!: string | null;

  published_at!: string | null;

  is_draft!: boolean;
}
